/*
 *  -----------------------------------------------------------------------
 *    <copyright file="warning-for-dialog.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from '@hooks/index';

import './warning-for-dialog.scss';

interface WarningForDialogInterface {
    firstNumber?: number | string;
    secondNumber?: number | string;
    customText?: string;
    type?: string;
    noMb?: boolean;
}

const WarningForDialog = ({ firstNumber = 0, secondNumber = 0, customText, type, noMb }: WarningForDialogInterface) => {
    const { t } = useTranslation();

    const setText = (textType: string | undefined): string | undefined => {
        let result = '';
        switch (textType) {
            case 'control':
                if (firstNumber > 0 && secondNumber > 0)
                    result = t('ra:controlWarningMessage', { cvNumber: firstNumber, riskNumber: secondNumber });
                else if (firstNumber > 0) result = t('ra:cvOnlyWarningMessage', { cvNumber: firstNumber });
                else if (secondNumber > 0) result = t('ra:riskOnlyWarningMessage', { riskNumber: secondNumber });
                break;
            case 'risk':
                if (firstNumber > 0 && secondNumber > 0)
                    result = t('ra:riskWarningMessage', { controlNumber: firstNumber, cvNumber: secondNumber });
                else if (firstNumber > 0) result = t('ra:controlOnlyWarningMessage', { controlNumber: firstNumber });
                else if (secondNumber > 0) result = t('ra:cvOnlyWarningMessage', { cvNumber: secondNumber });
                break;
            case 'CV':
                if (firstNumber > 0 && secondNumber > 0)
                    result = t('ra:cvWarningMessage', { controlNumber: firstNumber, riskNumber: secondNumber });
                else if (firstNumber > 0) result = t('ra:controlOnlyWarningMessage', { controlNumber: firstNumber });
                else if (secondNumber > 0) result = t('ra:riskOnlyWarningMessage', { riskNumber: secondNumber });
                break;
            case 'product':
                if (firstNumber > 0 && secondNumber > 0)
                    result = t('admin:productWarningMessage', {
                        studyNumber: firstNumber,
                        programsNumber: secondNumber,
                    });
                else if (firstNumber > 0)
                    result = t('admin:productWarningMessageOnlyStudy', { studyNumber: firstNumber });
                else if (secondNumber > 0)
                    result = t('admin:productWarningMessageOnlyProgram', { programsNumber: secondNumber });
                break;
            default:
                result = '';
        }
        return `${result} ${t('ra:updatesWillBeVisible')}`;
    };

    return firstNumber || secondNumber || customText ? (
        <div className={`warning-for-dialog ${noMb ? 'no-mb' : ''}`}>
            <FontAwesomeIcon className="warning-icon" icon={['fal', 'exclamation-triangle']} />
            {customText || setText(type)}
        </div>
    ) : null;
};

export default WarningForDialog;
